function buildMenu (allowed) {
    return [
    {
      title: 'Super Admin',
      icon: 'mdi-account-cog',
      items: [
        {
          title: 'Orchestration',
          icon: 'mdi-atom',
          path: '/SupOrchestration'
        },
        {
          title: 'Orchestration Node',
          icon: 'mdi-atom',
          path: '/SupOrchestrationNode'
        },
        {
          title: 'New Account', 
          icon: 'mdi-account', 
          path: '/SupNewAccount'
        },
        {
          title: 'States', 
          icon: 'mdi-map-outline', 
          path: '/SupStates'
        },
        {
          title: 'Users', 
          icon: 'mdi-account', 
          path: '/SupUsers'
        },
        {
          title: 'Orgs', 
          icon: 'mdi-domain', 
          path: '/SupOrgs'
        },
        {
          title: 'Provisions', 
          icon: 'mdi-tune', 
          path: '/SupProvisions'
        },
        {
          title: 'Integrations', 
          icon: 'mdi-domain', 
          path: '/SupIntegrations'
        },
        {
          title: 'System Variables',
          icon: 'mdi-domain',
          path: '/SupGoldenVars'
        },
        {
          title: 'Heartbeat',
          icon: 'mdi-heart-pulse',
          path: '/SupHeart'
        },
        {
          title: 'Login Summary', 
          icon: 'mdi-account', 
          path: '/SupLoginSummary'
        },
        {
          title: 'Schema', 
          icon: 'mdi-table-large', 
          path: '/SupSchema'
        },
        {
          title: 'Dictionary', 
          icon: 'mdi-book-alphabet', 
          path: '/SupDictionary'
        },
        {
          title: 'Phrase Mapper', 
          icon: 'mdi-web', 
          path: '/SupPhrasemap'
        },
        {
          title: 'BOTS', 
          icon: 'mdi-robot', 
          path: '/SupBots'
        },
        {
          title: "BOT Actions",
          icon: 'mdi-apple-keyboard-command',
          path: '/SupBotActions'
        },
        {
          title: 'BOT Messages',
          icon: 'mdi-message-text',
          path: '/SupBotMsg'
        },
        {
          title: 'Email Structure',
          icon: 'mdi-email-newsletter',
          path: '/SupEmailStructure'
        },
        {
          title: 'Bot Status',
          icon: 'mdi-information-outline',
          path: '/SupStatus'
        },
        {
          title: 'Firmwares',
          icon: 'mdi-sd',
          path: '/SupFirmwares'
        },
        {
          title: 'Calendar',
          icon: 'mdi-calendar',
          path: '/SupCalendar'
        },
        {
          title: 'Docs',
          icon: 'mdi-file-document',
          path: '/SupDocs'
        },
        {
          title: 'Current Services',
          icon: 'mdi-toolbox-outline',
          path: '/SupServices'
        },
        {
          title: 'File Manager',
          icon: 'mdi-folder-open-outline',
          path: '/SupFileUpload'
        },
        {
          title: 'Document Editor',
          icon: 'mdi-pencil',
          path: '/HTMLEditor'
        },
        {
          title: 'Pipelines',
          icon: 'mdi-pipe',
          path: '/SupPipelines'
        },
        {
          title: 'Plans',
          icon: 'mdi-alarm-panel-outline',
          path: '/SupPlans'
        }, 
        {
          title: 'Module List',
          icon: 'mdi-sim-outline',
          path: '/SupModules'
        },
        {
          title: 'Scheduled Tasks',
          icon: 'mdi-clock-outline',
          path: '/SupTasks'
        },
        {
          title: 'Policy List',
          icon: 'mdi-bookshelf',
          path: '/SupPolicy'
        },
        {
          title: 'Dispatch Log',
          icon: 'mdi-database-alert',
          path: '/SupDispatchLog'
        },
        {
          title: 'Workflow Table',
          icon: 'mdi-clipboard-list',
          path: '/SupWorkflowTable'
        },
        {
          title: 'Workflows',
          icon: 'mdi-clipboard-flow',
          path: '/SupWorkflows'
        },
				{
          title: 'App Workflows',
          icon: 'mdi-repeat',
          path: '/SupAppWorkflows'
        },
				{
          title: 'App Documents',
          icon: 'mdi-file-document-outline',
          path: '/SupAppDocuments'
        },
				{
          title: 'App Dashboards',
          icon: 'mdi-view-dashboard',
          path: '/SupAppDashboards'
        },
        {
          title: 'Table Cleanup',
          icon: 'mdi-table-large-remove',
          path: '/SupTableRemove'
        },
        {
          title: 'Workflow Routing',
          icon: 'mdi-routes',
          path: '/SupWorkflowRouting'
        },
        {
          title: 'Debug',
          icon: 'mdi-spider',
          path: '/SupDebug'
        },
        {
          title: 'METRC Default Settings',
          icon: 'mdi-alpha-m-circle-outline',
          path: '/METRCDefaults'
        },
        {
          title: 'METRC State Routes',
          icon: 'mdi-alpha-m-circle-outline',
          path: '/METRCStates'
        },
        {
          title: 'Servers',
          icon: 'mdi-server',
          path: '/SupServers'
        },
        {
          title: 'Server Class',
          icon: 'mdi-select-group',
          path: '/SupServerClass'
        },
        {
          title: 'Forms',
          icon: 'mdi-form-select',
          path: '/SupForms'
        },
        {
          title: 'Org Menus',
          icon: 'mdi-silverware',
          path: '/SupOrgMenus'
        },
        {
          title: 'Entitlements',
          icon: 'mdi-sim',
          path: '/SupEntitlements'
        },
        {
          title: 'Face Recognition',
          icon: 'mdi-face-recognition',
          path: '/SupFaceRecognition'
        }
      ]
    }
  ] 
}

export default buildMenu